import { DetailedHTMLProps, forwardRef, LabelHTMLAttributes, memo, ReactNode, useId } from "react";
import classNames from "classnames";
import { CheckboxBase, CheckboxBaseProps } from "../../CheckboxBase";

import styles from "./styles.module.scss";

export type CheckboxGroupCardSize = "sm" | "md";


export type CheckboxGroupCardItemProps = Omit<CheckboxBaseProps, "checkboxBaseSize"> & {
  checkboxBaseClassName?: string,
  contentClassName?: string,
  checkboxSize?: CheckboxGroupCardSize,
  labelProps?: Omit<DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>, "className">
  header: ReactNode,
  inputPosition?: "start" | "end",
}

export const CheckboxGroupCardItem = memo(forwardRef<HTMLSpanElement, CheckboxGroupCardItemProps>((
  {
    checkboxBaseClassName,
    inputPosition = "end",
    checkboxSize,
    children,
    className,
    contentClassName,
    disabled,
    id,
    header,
    labelProps,
    ...props
  }, ref,
) => {
  const reactId = useId();
  const realId = id || reactId;

  return (
    <label
      {...labelProps}
      className={classNames(
        styles.root,
        className,
        styles[checkboxSize as keyof typeof styles],
        {
          [styles.disabled]: disabled,
          [styles.selected]: props.value,
        },
      )}
      htmlFor={realId}
    >
      <div className={classNames(
        styles.header,
        {
          [styles.reverted]: inputPosition === "start",
        }
      )}>
        <div className={styles.headerContent}>
          {header}
        </div>
        <CheckboxBase
          ref={ref}
          checkboxBaseSize={checkboxSize}
          className={classNames(styles.checkboxBase, checkboxBaseClassName)}
          disabled={disabled}
          id={realId}
          {...props}
        />
      </div>
      <div className={classNames(styles.content, contentClassName)}>
        {children}
      </div>
    </label>
  );
}));